import { Dictionary } from '../../../../../types/dictionary';

export interface ValidationLocationParameters<T> {
  pathParams?: Dictionary<unknown>;
}
